class toggleAnimation extends HTMLElement {
  constructor() {
    super();

    if (this.classList.contains('admin-panel--no-js')) return;

    (this.accordion = 'chm-toggle--accordion'),
      (this.toggleClass = '.chm-toggle'),
      (this.toggleContent = '.chm-toggle__content');
    this.boxes = this.querySelectorAll('summary');

    if (!this.boxes.length) return;
    this.bindEvents();
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler.bind(this), false);
  }
  bindEvents() {
    const _this = this;
    this.boxes.forEach((box) => {
      box.addEventListener('click', (event) => {
        event.preventDefault();
        /*window.dispatchEvent(new Event('toggleAnimationStart'));
        setTimeout(function(){
          window.dispatchEvent(new Event('toggleAnimationEnd'));
        }, 300);*/
        var details = event.target.closest(_this.toggleClass),
          content = details.querySelector(_this.toggleContent),
          childs = _this.querySelectorAll('[open]');
        if (details.hasAttribute('open')) {
          details.classList.remove('toggle-opening');
          if (!_this.classList.contains(_this.accordion)) {
            setTimeout(function () {
              details.removeAttribute('open');
            }, 300);
            return false;
          }
        } else {
          details.setAttribute('open', '');
          setTimeout(function () {
            _this.resizeHandler();
            details.classList.add('toggle-opening');
          }, 0);
        }
        if (childs.lenght <= 0 || !_this.classList.contains(_this.accordion))
          return false;
        childs.forEach((child) => {
          child.classList.remove('toggle-opening');
          setTimeout(function () {
            child.removeAttribute('open');
          }, 300);
        });
      });
    });
  }
  resizeHandler() {
    const boxes = this.querySelectorAll('[open] ' + this.toggleContent);
    boxes.forEach((box) => {
      box.style.setProperty('--scroll-height', box.scrollHeight + 1 + 'px');
    });
  }
}
customElements.define('toggle-component', toggleAnimation);
